<!--
 * @Description: 掩码
 * @Author: cxh
 * @Date: 2022-05-24 16:25:08
 * @LastEditTime: 2022-06-29 11:10:27
 * @LastEditors: cxh
-->
<template>
  <div class="mask">
    <template v-if="maskContact && maskContact[maskKey] && maskContact.hideMask">
      <p :title="maskContact[maskKey]">{{ maskContact[maskKey] || '--' }}</p>
      <img src="@/assets/browse.svg" v-if="text" class="mask-eye" @click="hideMessage" />
    </template>
    <template v-else>
      <p :title="text">{{ text || '--' }}</p>
      <img src="@/assets/browse-off.svg" v-if="text" class="mask-eye" @click="showMessage" />
    </template>
  </div>
</template>
<script lang="ts" setup name="MoreButton">
import { computed } from 'vue'
const props = defineProps({
  text: String,
  dataIndex: [String, Array],
  maskContact: Object
})
const maskKey = computed(() => {
  if (Array.isArray(props.dataIndex)) {
    return props.dataIndex[props.dataIndex.length - 1]
  }
  return props.dataIndex
})
const emit = defineEmits(['show', 'hide'])
const showMessage = () => {
  emit('show')
}
const hideMessage = () => {
  emit('hide')
}
</script>
<style scoped lang="scss">
.mask {
  p {
    overflow: hidden;
    float: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: calc(100% - 20px);
  }
  .mask-eye {
    width: 14px;
    float: left;
    margin-left: 5px;
    margin-top: 5px;
    cursor: pointer;
  }
}
</style>
